import { useState, useEffect } from 'react';
export var BREAKPOINTS;
(function (BREAKPOINTS) {
    BREAKPOINTS["SM"] = "sm";
    BREAKPOINTS["MD"] = "md";
    BREAKPOINTS["LG"] = "lg";
    BREAKPOINTS["XL"] = "xl";
    BREAKPOINTS["2XL"] = "2xl";
})(BREAKPOINTS || (BREAKPOINTS = {}));
/**
 * breakpoints values in px
 */
export var breakpoints = {
    base: 0,
    sm: 480,
    md: 768,
    lg: 992,
    xl: 1280,
    '2xl': 1536,
};
/**
 *
 * @returns enum BREAKPOINTS
 */
export function useBreakpoint() {
    var _a = useState(BREAKPOINTS.SM), breakpoint = _a[0], setBreakpoint = _a[1];
    function handleResize() {
        if (window.innerWidth < breakpoints.sm) {
            setBreakpoint(BREAKPOINTS.SM);
        }
        else if (window.innerWidth < breakpoints.md) {
            setBreakpoint(BREAKPOINTS.MD);
        }
        else if (window.innerWidth < breakpoints.lg) {
            setBreakpoint(BREAKPOINTS.LG);
        }
        else if (window.innerWidth < breakpoints.xl) {
            setBreakpoint(BREAKPOINTS.XL);
        }
        else if (window.innerWidth < breakpoints['2xl']) {
            setBreakpoint(BREAKPOINTS['2XL']);
        }
    }
    useEffect(function () {
        if (typeof window === 'undefined')
            return;
        handleResize();
        window.addEventListener('resize', handleResize);
        // eslint-disable-next-line consistent-return
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    return breakpoint;
}
